import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { IMAGES } from "../../lib/images";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);
  return null;
}

export default function SiteLayout() {
  const { pathname } = useLocation();
  return (
    <div className="relative min-h-screen">
      {/* one single, static brand watermark behind the whole page */}
      <div className="lk-watermark" aria-hidden="true" data-testid="page-watermark">
        <img src={IMAGES.brand.watermark} alt="" />
      </div>

      <a href="#main" className="skip-link">
        Skip to content
      </a>
      <ScrollToTop />
      <Navbar />
      <main id="main" key={pathname} className="page-enter">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
